module.exports = __webpack_public_path__ + "img/gbp.2e9e17e9.svg";